import type { MouseEvent } from 'react';
import type { RelationWithoutHydration } from '../../../lib/flotiq-client/types/api-response';

import { useTranslation } from 'react-i18next';

import { getTestProps } from '../../../lib/helpers';

import { defaultButtonsProps, useModals } from '../../../contexts/ModalContext';

import { LinkIcon } from '../../../images/shapes';

import RelationModalContent from '../../RelationModalContent/RelationModalContent';

const RelationCellRender = ({
  data,
  testId,
}: {
  data: RelationWithoutHydration[];
  testId?: string;
}) => {
  const { t } = useTranslation();
  const modal = useModals();

  const showRelationsModal = async (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();

    await modal({
      id: 'relation-modal',
      content: <RelationModalContent relationsRawData={data} testId={testId} />,
      buttons: [
        {
          ...defaultButtonsProps.cancel,
          label: t('Global.Close'),
          key: 'Close',
        },
      ],
      size: 'lg',
      dialogAdditionalClasses: 'max-h-[calc(100vh-50px)]',
      ...getTestProps(testId, 'relations-modal', 'testId'),
    });
  };

  return (
    <button
      className="bg-blue rounded-lg px-2 py-0.5 inline-flex items-center text-white cursor-pointer"
      onClick={showRelationsModal}
      {...getTestProps(testId, 'relations-cell-button')}
    >
      <LinkIcon className="w-3.5 h-3.5 mr-1" />
      {data.length}
    </button>
  );
};

export default RelationCellRender;
